// Admin "view as user" state. Kept in sessionStorage so it is scoped to the tab the admin
// opened, survives reloads, and never leaks into the admin's other tabs (the Supabase
// session in localStorage is shared across tabs, so it can't be swapped instead).
const VIEW_AS_USER_ID_KEY = "viewAsUserId";
const VIEW_AS_USER_NAME_KEY = "viewAsUserName";
const VIEW_AS_IS_TEST_USER_KEY = "viewAsIsTestUser";
const VIEW_AS_QUERY_PARAM = "viewAs";
const VIEW_AS_NAME_QUERY_PARAM = "viewAsName";
const VIEW_AS_IS_TEST_USER_QUERY_PARAM = "viewAsTest";

export const VIEW_AS_USER_HEADER = "X-View-As-User";

export function initViewAsFromUrl() {
  const url = new URL(window.location.href);
  const userId = url.searchParams.get(VIEW_AS_QUERY_PARAM);
  if (!userId) {
    return;
  }

  sessionStorage.setItem(VIEW_AS_USER_ID_KEY, userId);
  sessionStorage.setItem(
    VIEW_AS_USER_NAME_KEY,
    url.searchParams.get(VIEW_AS_NAME_QUERY_PARAM) ?? ""
  );
  sessionStorage.setItem(
    VIEW_AS_IS_TEST_USER_KEY,
    url.searchParams.get(VIEW_AS_IS_TEST_USER_QUERY_PARAM) ?? "false"
  );

  url.searchParams.delete(VIEW_AS_QUERY_PARAM);
  url.searchParams.delete(VIEW_AS_NAME_QUERY_PARAM);
  url.searchParams.delete(VIEW_AS_IS_TEST_USER_QUERY_PARAM);
  window.history.replaceState(window.history.state, "", url);
}

export function getViewAsUserId(): string | null {
  return sessionStorage.getItem(VIEW_AS_USER_ID_KEY);
}

export function getViewAsUserName(): string {
  return sessionStorage.getItem(VIEW_AS_USER_NAME_KEY) ?? "";
}

// Display only. The backend decides whether writes are allowed.
export function isViewingAsTestUser(): boolean {
  return sessionStorage.getItem(VIEW_AS_IS_TEST_USER_KEY) === "true";
}

export function isViewingAs(): boolean {
  return getViewAsUserId() !== null;
}

export function buildViewAsUrl(userId: string, userName: string, isTestUser: boolean): string {
  const params = new URLSearchParams({
    [VIEW_AS_QUERY_PARAM]: userId,
    [VIEW_AS_NAME_QUERY_PARAM]: userName,
    [VIEW_AS_IS_TEST_USER_QUERY_PARAM]: String(isTestUser),
  });
  return `/home?${params.toString()}`;
}

export function exitViewAs() {
  sessionStorage.removeItem(VIEW_AS_USER_ID_KEY);
  sessionStorage.removeItem(VIEW_AS_USER_NAME_KEY);
  sessionStorage.removeItem(VIEW_AS_IS_TEST_USER_KEY);
  window.close();
  // window.close() is ignored when the tab wasn't opened by script (e.g. a pasted URL).
  window.location.href = "/admin";
}
